import { render, staticRenderFns } from "./TabelaDashboardAtendimentos.vue?vue&type=template&id=47f6e2ca&scoped=true"
import script from "./TabelaDashboardAtendimentos.vue?vue&type=script&lang=js"
export * from "./TabelaDashboardAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6e2ca",
  null
  
)

export default component.exports